import * as API from "../General/api";
 

export function getStatsCall(jobId) {
  return API.getRequest(API.apiUrls.getStats.getAllStats + `?JobId=${jobId}`);
} 
